import React from 'react';
import PropTypes from 'prop-types';


const FeaturesAttr = function FeaturesAttrComponent({ value }) {
  const values = value.split(', ');

  return (
    values.length > 1 ?
      (
        <div className="product-table__table-cell--features">
          <ul className="product-table__feaures-list">
            { values.map(item => (
              <li key={item} className="product-table__feaures-item">{item}</li>
            )) }
          </ul>
        </div>
      ) :
      (
        <div>
          <div>{value}</div>
        </div>
      )
  );
};

FeaturesAttr.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.string)]),
};

FeaturesAttr.defaultProps = {
  value: [],
};

export default FeaturesAttr;
